import "../scss/main.scss";
import "bootstrap";
import "./navbar.js";
import "./newsletter_form.js";
import { showCookieDialog, bindCloseListener } from "./cookie_info";

showCookieDialog();
bindCloseListener();
